import {AppState, Configuration} from "../services/configuration";
import {MessageProvider, MessageType} from "../services/messageProvider";
import {findDOMfromVNode} from "inferno";
import {LegState} from "@sap/cpaas-commlib-lib";

let allowChange = false;
let originX: number = null;
let originY: number = null;
let messageType: MessageType;
let sizeX: number = null;
let sizeY: number = null;

export function calculateSize(): { x: number, y: number } {
	const app = document.getElementById("cvc-app");
	return { x: app.offsetWidth, y: app.offsetHeight };
}

export function resizeApp(x?: number, y?: number, force?: boolean, id?: string) {
	const app = document.getElementById("cvc-app");
	x = x ? x : app.offsetWidth;
	y = y ? y : app.offsetHeight;
	x = x > Configuration.maxWidth && !force ? Configuration.maxWidth : x;
	y = y > Configuration.maxHeight && !force ? Configuration.maxHeight : y;
	AppState.width = x;
	AppState.height = y;
	// Resize frame
	MessageProvider.sendMessage(MessageType.resize, {x, y, force, id});
}

export function moveApp(x?: number, y?: number, force?: boolean) {
	MessageProvider.sendMessage(MessageType.move, { x, y, force });
}

export function startContainerChange(event: MouseEvent, type: MessageType) {
	if (type === MessageType.move && (event.target as HTMLElement).nodeName !== "NAV") {
		// Not the navbar
		return;
	}
	MessageProvider.sendMessage(MessageType.animate, false);
	allowChange = true;
	originX = event.clientX;
	originY = event.clientY;
	const app = document.getElementById("cvc-app");
	sizeX = app.offsetWidth;
	sizeY = app.offsetHeight;
	messageType = type;
	document.addEventListener("mousemove", containerChange);
	document.addEventListener("mouseup", stopContainerChange);
	// document.body.style.cursor = type === MessageType.move ? "move" : "nw-resize";
}

export function stopContainerChange(event: MouseEvent) {
	allowChange = false;
	document.removeEventListener("mousemove", containerChange);
	document.removeEventListener("mouseup", stopContainerChange);
	// document.getElementById("cvc-app").style.cursor = "";
	MessageProvider.sendMessage(MessageType.animate, true);
}

export function containerChange(event: MouseEvent) {
	if (allowChange) {
		let x = -1 * (originX - event.clientX);
		let y = -1 * (originY - event.clientY);
		if (messageType === MessageType.resize) {
			x += sizeX;
			y += sizeY;
		}
		MessageProvider.sendMessageWaitResponse(messageType, { x, y, add: messageType === MessageType.move, animation: false }).then(() => allowChange = true);
	}
}

// https://stackoverflow.com/questions/487073/how-to-check-if-element-is-visible-after-scrolling
export function isScrolledIntoView(element: HTMLElement) {
	const rect = element.getBoundingClientRect();
	const elemTop = rect.top;
	const elemBottom = rect.bottom;
	return ((elemTop >= 0) && (elemBottom <= window.innerHeight));
}

export function downloadURI(uri: string, name: string) {
	const link = document.createElement("a");
	link.download = name;
	link.href = uri;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}

export function formatMediaLength(seconds: number) {
	const hours = Math.floor(seconds / 3600);
	seconds %= 3600;
	const minutes = Math.floor(seconds / 60);
	seconds = Math.floor(seconds % 60);
	return (hours ? pad0(hours, 2) + ":" : "") + pad0(minutes, 2) + ":" + pad0(seconds, 2);
}

export function pad0(input: number | string, width: number): string {
	input = String(input);
	if (input.length > width) {
		return input;
	}
	return ("000" + input).slice(-width);
}

export function formatSize(bytes: number, decimals: number = 2) {
	if (bytes === 0) {
		return "0 Bytes";
	}
	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
	const i = Math.floor(Math.log(bytes) / Math.log(k));
	return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + sizes[i];
}

export function findDOMNode(ref: any) {
	if (ref && ref.nodeType) {
		return ref;
	}

	if (!ref || ref.$UN) {
		return null;
	}

	if (ref.$LI) {
		return findDOMfromVNode(ref.$LI, true);
	}

	if (ref.flags) {
		return findDOMfromVNode(ref, true);
	}

	return null;
}

export function guid(): string {
	return String(Math.floor(Math.random() * (4611686018427387903 - 1)) + 1);
}

export function chatProceeding() {
	return AppState.activeLeg?.getState() === LegState.proceeding || AppState.activeLeg?.getState() === LegState.connected;
}
